import { tabType, tabTypeToPaymentMethodMap } from '../../constants';
var PaymentTabLabel;
(function (PaymentTabLabel) {
    PaymentTabLabel["lease"] = "Shared.Common.leaseMethodLabel";
    PaymentTabLabel["finance"] = "Shared.Common.financeMethodLabel";
    PaymentTabLabel["rebate"] = "Shared.Common.rebateMethodLabel";
})(PaymentTabLabel || (PaymentTabLabel = {}));
function getAvailableOffers(paymentMethod, offers) {
    var _a, _b, _c;
    const sortedOffers = [];
    const incentiveOffers = (_a = offers.incentiveOffers[paymentMethod]) !== null && _a !== void 0 ? _a : [];
    const loyaltyOffers = (_b = offers.loyaltyOffers[paymentMethod]) !== null && _b !== void 0 ? _b : [];
    const bonusOffers = (_c = offers.bonusOffers[paymentMethod]) !== null && _c !== void 0 ? _c : [];
    incentiveOffers.forEach(({ key, name }) => {
        sortedOffers.push({ key, name: name });
    });
    loyaltyOffers.forEach(({ key, name }) => {
        sortedOffers.push({ key, name: name });
    });
    bonusOffers.forEach(({ title, description }) => {
        sortedOffers.push({ key: title.value, name: title.value, disclaimer: description.value });
    });
    return sortedOffers;
}
function buildPaymentTab(type, offers, cashRebate, apr, term, paymentAmount, paymentFrequency) {
    const paymentMethod = tabTypeToPaymentMethodMap[type];
    const availableOffers = getAvailableOffers(paymentMethod, offers);
    if (type === tabType.rebate) {
        // Rebate tab should only show the cash rebate amount
        if (cashRebate === undefined)
            return null;
        return {
            type,
            key: type,
            label: PaymentTabLabel[type],
            content: {
                rebateAmount: cashRebate,
                availableOffers,
            },
        };
    }
    return {
        type,
        key: type,
        label: PaymentTabLabel[type],
        content: {
            apr: {
                value: apr,
                showSpecialIcon: false, // Todo: implement this display logic https://hondaca.atlassian.net/browse/APT-270
            },
            term,
            paymentAmount,
            paymentFrequency,
            paymentMethod,
            availableOffers,
        },
    };
}
export default buildPaymentTab;
